type Handler = (e: CustomEvent) => void;

const listeners = new Map<string, Set<Handler>>();

export const events = {
  on(event: string, handler: Handler) {
    if (!listeners.has(event)) listeners.set(event, new Set());
    listeners.get(event)!.add(handler);
  },
  off(event: string, handler: Handler) {
    listeners.get(event)?.delete(handler);
  },
  emit(event: string, detail?: unknown) {
    const e = new CustomEvent(event, { detail, bubbles: true, composed: true, cancelable: true });
    listeners.get(event)?.forEach((h) => h(e));
    // Also emit on document for element-level listeners
    document.dispatchEvent(e);
  },
};

// Bridge a minimal global API compatible with queueing
function initGlobal() {
  const g = (window.Wandway = window.Wandway || ({} as any));
  g.on = (event: string, handler: Handler) => events.on(event, handler);
  g.off = (event: string, handler: Handler) => events.off(event, handler);
  g.emit = (event: string, detail?: unknown) => events.emit(event, detail);
  if (Array.isArray(g.q)) {
    // Drain any queued calls: [method, ...args]
    const q = g.q.slice();
    g.q.length = 0;
    for (const item of q) {
      if (!Array.isArray(item) || item.length === 0) continue;
      const [method, ...args] = item as ["on" | "off" | "emit", ...any[]];
      if (method === "on") g.on(args[0], args[1]);
      if (method === "off") g.off(args[0], args[1]);
      if (method === "emit") g.emit(args[0], args[1]);
    }
  }
}

initGlobal();

export const EVENT_ADD_TO_CART = "ww:add-to-cart";
export const EVENT_NAVIGATE_CHAT = "ww:navigate:chat";
export const EVENT_NAVIGATE_PRODUCT = "ww:navigate:product";
export const EVENT_STATUS = "ww:status";
export const EVENT_DELTA = "ww:delta";
export const EVENT_CANDIDATES = "ww:candidates";
export const EVENT_CLOSE = "ww:close";
export const EVENT_LOCALE_SET = "ww:locale:set";
export const EVENT_RECOMMENDATIONS_UPDATED = "ww:recommendations:updated";
export const EVENT_RECOMMENDATIONS_LOADING = "ww:recommendations:loading";
export const EVENT_CHECKOUT_RECOMMENDATIONS_UPDATED = "ww:checkout-recommendations:updated";
export const EVENT_CHECKOUT_RECOMMENDATIONS_LOADING = "ww:checkout-recommendations:loading";
export const EVENT_QA_USED = "ww:qa:used";


